import React, { useMemo } from 'react';
import '../../../styles/service-pages.scss';
import ServiceDetailCards from '../../../components/ServiceDetailCards';
import LatestWorkGrid from '../../../components/LatestWorkGrid';
import Seo from '../../../components/Seo';

const UxDesign = () => {
  const detailItems = useMemo(() => [
    {
      title: 'Approach',
      description:
        "We follow a research-first, iterate-always model. Discovery work comes before design work — always. We'll talk to your users (or help you find them), map their mental models, identify the moments of friction and the opportunities you're missing, and design against real evidence. We test early, fail cheap, and ship with confidence.",
    },
    {
      title: 'Delivery',
      description:
        "UX engagements deliver: user research reports, journey maps and experience maps, information architecture, wireframes and interactive prototypes, usability test findings, and design recommendations. Everything documented clearly enough that your team can build on it — and revisit it in six months when priorities shift.",
    },
    {
      title: 'Results',
      description:
        "Measurable improvements in conversion, retention, and user satisfaction. Reduced support burden. Faster onboarding. And the slightly smug satisfaction of watching your NPS score go up after doing the work properly.",
    },
  ], []);

  return (
    <>
      <Seo 
        title="UX Design Services | Heretic Studio"
        description="We design experiences that people actually enjoy using. By understanding real user behavior, we uncover pain points, simplify journeys, and create products that feel intuitive from the first interaction."
      />
      <div className="studio-page service-page service-page--ux-design">
        <div className="studio-hero service-hero">
          <div className="studio-hero__content service-hero__content">
            <h1 className="studio-hero__title service-hero__title">UX Design</h1>
            <p className="studio-hero__subtitle service-hero__subtitle">User-centric design</p>
          </div>
        </div>

        <section className="section intro service-intro">
          <div className="wrapper grid-display">
            <div className="row">
              <div className="col-12">
                <div className="blur-text blur-text--1 large center-text introtext">
                 Leveraging user behavior, pain points, and user journeys, to create intuitive products
                </div>
              </div>
            </div>
          </div>
        </section>

        <ServiceDetailCards items={detailItems} />

        <LatestWorkGrid />
      </div>
    </>
  );
};

export default UxDesign;
